import { JOB_OPENING_TWO_COL_ROW } from '@/components/job-opening-identity'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export type ListCardSkeletonProps = {
  /** Row inside a parent list (employer jobs) — omits outer Card chrome. */
  embedded?: boolean
  /** Show footer action bar stub. */
  showFooter?: boolean
  className?: string
}

function ListCardSkeletonBody({ showFooter = true }: { showFooter?: boolean }) {
  return (
    <>
      <div className={JOB_OPENING_TWO_COL_ROW}>
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <Skeleton className="size-12 shrink-0 rounded-xl" />
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-5 w-2/3 max-w-xs" />
            <Skeleton className="h-4 w-1/2 max-w-[10rem]" />
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-5 w-16 rounded-md" />
              <Skeleton className="h-5 w-20 rounded-md" />
            </div>
          </div>
        </div>
        <div className="flex shrink-0 gap-2">
          <Skeleton className="h-8 w-20 rounded-md" />
        </div>
      </div>
      {showFooter ? (
        <div className="mt-3 flex flex-wrap items-center gap-3 border-t border-border/60 pt-3">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-16" />
        </div>
      ) : null}
    </>
  )
}

export function ListCardSkeleton({
  embedded = false,
  showFooter = true,
  className,
}: ListCardSkeletonProps) {
  if (embedded) {
    return (
      <div
        className={cn('rounded-lg border border-border/60 bg-card p-[var(--sp-card)]', className)}
        aria-hidden
      >
        <ListCardSkeletonBody showFooter={showFooter} />
      </div>
    )
  }

  return (
    <Card className={cn('flex h-full flex-col', className)} aria-hidden>
      <CardContent className="flex flex-1 flex-col p-[var(--sp-card)]">
        <ListCardSkeletonBody showFooter={showFooter} />
      </CardContent>
    </Card>
  )
}
